// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"62ed9b63","453":"79e41dd2"}[chunkId] + ".chunk.js";
};